export default __webpack_public_path__ + "static/materialbeskrivning_smedjan-1c2a4b96aa061cdbaebcf57025664462.pdf";